import { render, staticRenderFns } from "./LandmarkList.vue?vue&type=template&id=6dcd6e85"
import script from "./LandmarkList.vue?vue&type=script&lang=js"
export * from "./LandmarkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports